import { axios } from "../axios.instance";

export type GetReferralsUnreadCounterRequest = null;

export type GetReferralsUnreadCounterResponse = {
  count: number;
};

export const getReferralsUnreadCounter = async (): Promise<GetReferralsUnreadCounterResponse> => {
  const { data } = await axios.get(`/referral-requests/my/pending-requests-count`);

  return data;
};
